module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VG1005-6d58276090b00cbb851b354bee26e323.png";